/**
 * [结算模式]
 * @author: Fu Xiaochun
 * @date: 2022-05-30 
 */


import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import styles from './index.module.scss';
import { InputNumber, message, Radio, } from 'antd';

function SettleModel(props, ref){

    // 结算模式
    const [settleModel, setSettleModel] = useState('FULL');  // 结算模式
    const [platRatio, setPlatRatio] = useState();  // 平台比例
    const [riderRatio, setRiderRatio] = useState();  // 骑手比例
    const [companyRatio, setCompanyRatio] = useState();  // 小运力公司比例

    useImperativeHandle(ref, ()=>({
        getState: ()=>{
            return {
                settleModel,
                platRatio,
                riderRatio,
                companyRatio
            };
        }
    }));

    return (
        <div className={styles.settleModel}>
            <div className={styles.item}>
                <div className={styles.label}>结算模式：</div>
                <div className={styles.val}>
                    <Radio.Group onChange={e=>{setSettleModel(e.target.value);}} value={settleModel}>
                        <Radio value="FULL">全额结算</Radio>
                        <Radio value="REVENUE_ONLY">仅收益结算</Radio>
                    </Radio.Group>
                    <div className={styles.extTxt}>
                        {settleModel == 'FULL' && <p>配送单骑手的收益和小运力公司的收益全部结算给小运力运力公司</p>}
                        {settleModel == 'REVENUE_ONLY' && <p>配送单骑手的收益结算给骑手，小运力公司仅结算自身收益部分</p>}
                    </div>
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>平台服务费比例：</div>
                <div className={styles.val}>
                    <InputNumber addonAfter="%" className={styles.txt} value={platRatio} precision={2} min={0} max={100} placeholder="请输入" onChange={e=>{setPlatRatio(e);}} />
                    <div className={styles.extTxt}>平台服务费以配送费为基准计算</div>
                </div>
            </div>
            {settleModel == 'FULL' ? (
                <div className={styles.item}>
                    <div className={styles.label}>骑手配送流水比例：</div>
                    <div className={styles.val}>
                        <InputNumber addonAfter="%" className={styles.txt} value={riderRatio} precision={2} min={0} max={100} placeholder="请输入" onChange={e=>{setRiderRatio(e);}} />
                        <div className={styles.extTxt}>骑手端呈现配送费=(配送费-平台服务费)x呈现比例+小费</div>
                    </div>
                </div>
            ) : null}
            {settleModel == 'REVENUE_ONLY' ? (
                <div className={styles.item}>
                    <div className={styles.label}>小运力公司分润比例：</div>
                    <div className={styles.val}>
                        <InputNumber addonAfter="%" className={styles.txt} value={companyRatio} precision={2} min={0} max={100} placeholder="请输入" onChange={e=>{setCompanyRatio(e);}} />
                        <div className={styles.extTxt}>小运力分润比例以配送费实付金x平台服务费比例为基准计算</div>
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export default forwardRef(SettleModel);